module.exports = __webpack_public_path__ + "img/yellowvert.729d8079.png";